import { formieSymbol } from '~/layers/formie/formie-plugin';

export const getFormieComponent = (name) => {
    const formie = inject(formieSymbol);
    if(!formie) {
        throw new Error('Formie plugin not installed');
    }
    return formie.getComponent(name);
};
